
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { PoolModel } from 'models/generated/Entities.GormCrm.Pool';


const _gormCrm_PoolControllerHelper = new Map<string, Object>();
_gormCrm_PoolControllerHelper.set('GetAllPools', PoolModel);
_gormCrm_PoolControllerHelper.set('GetPoolById', PoolModel);
_gormCrm_PoolControllerHelper.set('GetUserPools', PoolModel);
_gormCrm_PoolControllerHelper.set('SavePool', PoolModel);


export const gormCrm_PoolControllerHelper = _gormCrm_PoolControllerHelper;

